import React from 'react';
import Cookies from 'js-cookie';
import { IoExitOutline } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';


const LogoutButton = () => {
    const navigate = useNavigate();

  const handleLogout = async () => {

    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logout`, {
        method: 'POST',
        credentials: "include"
    });
    console.log(response);
    if (response.ok) {
        console.log('Logged out successfully');
        Cookies.remove('session-id');
        navigate('/login');
    }
  };

  return (
    <button onClick={handleLogout} className="flex items-center gap-2 text-base">
        Logout
        <IoExitOutline className='w-6 h-6' />
    </button>
  );
};

export default LogoutButton;
